/** Search-only transliteration; labels and stored names always keep their spelling. */
const BULGARIAN_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ж: 'zh', з: 'z',
  и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p',
  р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch',
  ш: 'sh', щ: 'sht', ъ: 'a', ь: 'y', ю: 'yu', я: 'ya',
}

function fold(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '')
}

function latin(value: string, informal = false): string {
  // Transliterate before removing accents so й remains y, not и/i.
  return fold(value.replace(/[а-я]/g, (letter) => {
    // Common everyday spellings: izolacii as well as izolatsii, chaika/chayka.
    if (informal && letter === 'ц') return 'c'
    if (informal && letter === 'й') return 'i'
    return BULGARIAN_LATIN[letter] ?? letter
  }))
}

/** PrimeVue's default contains filter, extended with a hidden Latin search key. */
export function containsName(value: unknown, query: unknown, locale?: string): boolean {
  if (query === undefined || query === null || query === '') return true
  if (value === undefined || value === null) return false
  const label = String(value).normalize('NFC').toLocaleLowerCase(locale)
  const search = String(query).normalize('NFC').toLocaleLowerCase(locale)
  return fold(label).includes(fold(search))
    || latin(label).includes(latin(search))
    || latin(label, true).includes(latin(search, true))
}
